import { Row } from 'react-bootstrap';
import SupportImg from '../../assets/support-mobile-lady.png';
import Popover from '../Popover';

export type customSupportProps = React.PropsWithChildren<{}>;

const supportPopoverBody = (children: any) => (
  <section>
    <div className="p-0">
      <span className="text-sub fw-bold lh-xs">Need help?</span>
    </div>
    <Row className="m-0">{children}</Row>
  </section>
);

const SupportMobile = ({ children }: customSupportProps) => {
  return (
    <div style={{ width: 55, height: 55 }}>
      <Popover
        trigger="click"
        placement="bottom-end"
        popoverBody={supportPopoverBody(children)}
      >
        <img
          src={SupportImg}
          alt="support-img"
          className="rounded-circle"
          style={{ width: '100%' }}
        />
      </Popover>
    </div>
  );
};

export default SupportMobile;
